import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findOne(id, opciones = { params: {} }) {
    const config = {
      params: opciones.params,
    };

    if (opciones.params?.formato !== 'base64') {
      config.responseType = 'arraybuffer';
    }

    return await axiosIns.get(obtenerUrlAPIPagos(`programa-universidad-pdf/v2/${id}`), config);
  },
};
